import React, { Component } from "react";
import AntdSwitch, {SwitchProps} from 'antd/lib/switch';
import 'antd/lib/switch/style';

interface SProps extends SwitchProps {
    forwardedRef?: any;
};
class Switch extends Component<SProps> {
    render() {
        const { forwardedRef, ...rest } = this.props;
        return (
          <AntdSwitch ref={forwardedRef} {...rest} />
        )
    }
}
export default React.forwardRef((props: SProps, ref) => {
    return <Switch {...props} forwardedRef={ref} />
});







// WEBPACK FOOTER //
// ./src/components/switch/index.tsx